import { forwardRef, InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';
import { cln } from '../lib/utils';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  className?: string;
}

export const Input = forwardRef<HTMLInputElement, Props>(
  ({ label, error, className, placeholder, ...props }, ref) => {
    const { t } = useTranslation();
    const id = crypto.randomUUID();
    return (
      <span className={cln('input', className)}>
        {label && <label htmlFor={id}>{t(label)}</label>}
        <input
          {...props}
          ref={ref}
          id={id}
          placeholder={t(placeholder ? `placeholder.${placeholder}` : '')}
          className={error && 'invalid'}
        />
        {error && <span className="text-label text-danger-500">{t(error)}</span>}
      </span>
    );
  },
);

Input.displayName = 'Input';
